import { useState } from "react";
import API from "api/endpoints";
import { message } from "antd";
import axiosInstance from "api/axiosInstance";

function EmployeeContactService() {
  const [isLoading, setIsLoading] = useState(false);
  const personalId = localStorage.getItem("personalId");
  const [formData, setFormData] = useState({
    employeeId: Number(personalId),
    name: "",
    relation: "",
    phoneNo: "",
    homePhone: "",
    email: "",
    addressOne: "",
    addressTwo: "",
    city: "",
    state: "",
    postalCode: "",
    country: "",
  });

  const handleChange = (e, fieldName) => {
    if (typeof e === "string") {
      // Agar e string hai, to yeh PhoneInput ka case hoga
      setFormData((prevData) => ({
        ...prevData,
        [fieldName]: e,
      }));

      // Error clear karein agar value enter ki gayi ho
      if (e.trim() !== "") {
        setFormDataError((prevErrors) => ({
          ...prevErrors,
          [`${fieldName}Error`]: "",
        }));
      } else {
        setFormDataError((prevErrors) => ({
          ...prevErrors,
          [`${fieldName}Error`]: `${fieldName} is required.`,
        }));
      }
      return;
    }

    if (!e || !e.target) {
      console.error("Event or target is undefined:", e);
      return;
    }

    const { name, value } = e.target;

    // Clear the error message if the value is not empty
    if (value.trim() !== "") {
      setFormDataError((prevState) => ({
        ...prevState,
        [`${name}Error`]: "",
      }));
    } else {
      setFormDataError((prevState) => ({
        ...prevState,
        [`${name}Error`]: `${name} is required.`,
      }));
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  function validateValidation(formData, setFormDataError) {
    let hasError = false;

    Object.keys(formData).forEach((fieldName) => {
      if (
        (typeof formData[fieldName] === "string" &&
          (!formData[fieldName] || !formData[fieldName].trim())) || // For string fields
        (typeof formData[fieldName] === "number" &&
          (isNaN(formData[fieldName]) || formData[fieldName] === null)) // For numeric fields
      ) {
        const fieldNameWithSpaces = fieldName
          .replace(/([A-Z])/g, " $1")
          .replace(/^./, (str) => str.toUpperCase());
        setFormDataError((prevState) => ({
          ...prevState,
          [`${fieldName}Error`]: `${fieldNameWithSpaces} is required.`,
        }));
        hasError = true;
      }
    });

    if (hasError) {
      return false;
    }

    const allFieldsFilled = Object.values(formData).every((value) => {
      return (
        (typeof value === "string" && value.trim() !== "") ||
        (typeof value === "number" && !isNaN(value))
      );
    });

    if (!allFieldsFilled) {
      setFormDataError((prevState) => ({
        ...prevState,
        commonError: "Please fill in all fields before saving.",
      }));
      return false;
    }

    return true;
  }

  const handleSubmit = async () => {
    const isValid = validateValidation(formData, setFormDataError);
    if (isValid) {
      try {
        setIsLoading(true);
        const personalId = localStorage.getItem("personalId");
        const updatedFormData = {
          ...formData,
          employeeId: Number(personalId),
        };

        const response = await axiosInstance.post(
          API.employeeEmergencyContact.addEmergencyContact,
          updatedFormData
        );
        clearFields();
        message.success("Your Emergency Contact added successfully!");
      } catch (error) {
        if (error.response) {
          // If the error response is due to more than 2 contacts
          if (error.response.data === "You cannot add more than 2 emergency contacts.") {
            message.error("You cannot add more than 2 emergency contacts.");
            clearFields();
          } else {
            console.error("Server Error:", error.response.data);
            message.error(`Server Error: ${error.response.data}`);
          }
        } else if (error.request) {
          // No response received
          console.error("No response received:", error.request);
          message.error("No response received from the server.");
        } else {
          // Request setup error
          console.error("Error setting up request:", error.message);
          message.error(`Error: ${error.message}`);
        }
      } finally {
        setIsLoading(false);
      }
    }
  };

  const [formDataError, setFormDataError] = useState({
    nameError: "",
    relationError: "",
    phoneNoError: "",
    homePhoneError: "",
    emailError: "",
    addressOneError: "",
    addressTwoError: "",
    cityError: "",
    stateError: "",
    postalCodeError: "",
    countryError: "",
  });

  const clearFields = () => {
    const personalId = localStorage.getItem("personalId");

    setFormData({
      employeeId: Number(personalId),
      name: "",
      relation: "",
      phoneNo: "",
      homePhone: "",
      email: "",
      addressOne: "",
      addressTwo: "",
      city: "",
      state: "",
      postalCode: "",
      country: "",
    });
  };

  return {
    formData,
    setFormData,
    formDataError,
    setFormDataError,
    handleChange,
    clearFields,
    validateValidation,
    isLoading,
    handleSubmit,
  };
}

export default EmployeeContactService;
